import React from 'react';
import { DesignTokens, GivelifyIcon } from '@givelify/ui';
import { useEnvelopesContext } from '../../context/EnvelopesProvider';
import { EnvelopeListCheckmarkIcon, EnvelopeListIcon } from './styles';

interface EnvelopeListItemIconProps {
    id: number;
    active: boolean;
}

const EnvelopeListItemIcon: React.FCC<EnvelopeListItemIconProps> = (props) => {
    const { id, active } = props;

    const { updatePrioritiesRequestState, movedItemId, showCheckMark } =
        useEnvelopesContext();

    const itemIsMoved = movedItemId === id;
    const isMoving = updatePrioritiesRequestState === 'REQUEST_START';
    const isError = updatePrioritiesRequestState === 'REQUEST_ERROR';

    const currentItemIsMoving = itemIsMoved && isMoving;
    const currentItemIsError = itemIsMoved && isError;
    const otherItemIsMoving = !itemIsMoved && isMoving;

    return (
        <div>
            {currentItemIsError ? (
                <GivelifyIcon
                    color={DesignTokens.color.iconError}
                    fontSize={30}
                    variant="info-warning"
                />
            ) : itemIsMoved && showCheckMark ? (
                <EnvelopeListCheckmarkIcon variant="checkmarkSuccess" />
            ) : currentItemIsMoving ? (
                <EnvelopeListIcon spin variant="loading" />
            ) : (
                <EnvelopeListIcon
                    color={
                        (!active || otherItemIsMoving) &&
                        DesignTokens.color.iconDisabled
                    }
                    variant="move"
                />
            )}
        </div>
    );
};

export default EnvelopeListItemIcon;
